<div class="wrapper w-100 h-100">
  <img
    loading="lazy"
    src="assets/images/logos/vaki-logo-black&green.svg"
    class="w-50"
  />
</div>
